import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, Home, PlayCircle } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  const isActivePath = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
              <Link to="/" className="flex items-center space-x-2 rtl:space-x-reverse">
                <img
                  src="/assets/logo.png"
                  alt="شعار Feda Creativity أونلاين"
                  className="w-10 h-10 rounded-lg object-contain shadow-sm"
                  loading="lazy"
                  width={40}
                  height={40}
                />
                <span className="text-xl font-bold text-stone-900">Feda Creativity أونلاين</span>
              </Link>
            </div>

            <nav className="hidden md:flex items-center space-x-6 rtl:space-x-reverse">
              <Link
                to="/"
                className={`flex items-center space-x-2 rtl:space-x-reverse px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActivePath('/')
                    ? 'bg-amber-100 text-amber-700'
                    : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                <Home className="w-4 h-4" />
                <span>الرئيسية</span>
              </Link>
              
              <Link
                to="/courses"
                className={`flex items-center space-x-2 rtl:space-x-reverse px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActivePath('/courses')
                    ? 'bg-amber-100 text-amber-700'
                    : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                <PlayCircle className="w-4 h-4" />
                <span>الكورسات</span>
              </Link>
              
              <Link
                to="/profile"
                className={`flex items-center space-x-2 rtl:space-x-reverse px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActivePath('/profile')
                    ? 'bg-amber-100 text-amber-700'
                    : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                <User className="w-4 h-4" />
                <span>الملف الشخصي</span>
              </Link>
              
              <Link
                to="/admin"
                className={`flex items-center space-x-2 rtl:space-x-reverse px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActivePath('/admin')
                    ? 'bg-amber-100 text-amber-700'
                    : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                <User className="w-4 h-4" />
                <span>الإدارة</span>
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Mobile Navigation */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 px-4 py-2">
        <div className="flex justify-around items-center">
          <Link
            to="/"
            className={`flex flex-col items-center p-2 rounded-lg transition-colors ${
              isActivePath('/')
                ? 'text-amber-600'
                : 'text-stone-500'
            }`}
          >
            <Home className="w-5 h-5" />
            <span className="text-xs mt-1">الرئيسية</span>
          </Link>
          
          <Link
            to="/courses"
            className={`flex flex-col items-center p-2 rounded-lg transition-colors ${
              isActivePath('/courses')
                ? 'text-amber-600'
                : 'text-stone-500'
            }`}
          >
            <PlayCircle className="w-5 h-5" />
            <span className="text-xs mt-1">الكورسات</span>
          </Link>
          
          <Link
            to="/profile"
            className={`flex flex-col items-center p-2 rounded-lg transition-colors ${
              isActivePath('/profile')
                ? 'text-amber-600'
                : 'text-stone-500'
            }`}
          >
            <User className="w-5 h-5" />
            <span className="text-xs mt-1">الملف الشخصي</span>
          </Link>
        </div>
      </nav>

      {/* Mobile spacing */}
      <div className="md:hidden h-16" />
    </div>
  );
}